<template>
	<div v-if="showPagination" class="row">
		<div class="col-xs-12 col-sm-12 col-md-12 text-center">
			<ul class="pager">
				<li :class="{ disabled: pageDetails.currentPage == 1 }">
					<a
						@click="navigate(prevPage, $event)" 
						:disabled="pageDetails.currentPage == 1"
						class="btn btn-info btn-fill">
							<span aria-hidden="true">&laquo;</span>
							Prev
					</a>
				</li>

				<li :class="{ disabled: pageDetails.currentPage == pageDetails.lastPage }">
					<a
						@click="navigate(nextPage, $event)" 
						:disabled="pageDetails.currentPage == pageDetails.lastPage"
						class="btn btn-info btn-fill">
							Next
							<span aria-hidden="true">&raquo;</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['pageDetails', 'routeName'],

		computed: {
			prevPage() {
				return this.pageDetails.currentPage != 1 ? this.pageDetails.currentPage - 1 : 1;
			},

			nextPage() {
				return this.pageDetails.currentPage != this.pageDetails.lastPage ? this.pageDetails.currentPage + 1 : this.pageDetails.lastPage;
			},

			showPagination() {
				return this.pageDetails.total > this.pageDetails.perPage;
			}
		},

		methods: {
			navigate(pageNumber, event) {
				let element = $(event.target).is('span') ? $(event.target).parent('a') : $(event.target);
				
				if (element.attr('disabled') === 'disabled') {
					return;
				}

				let query = {
					page: pageNumber,
					per_page: this.pageDetails.perPage
				};

				this.$emit('navigate', query);
			}
		}
	}
</script>

<style scoped>
	.pagination-info {
		margin-top: 20px;
		color: #999999;
	}

	a {
		cursor: pointer !important;
	}

	a[disabled=disabled] {
		cursor: not-allowed !important;
	}	
</style>


// WEBPACK FOOTER //
// Pagination.vue?3b381164